module.exports = __webpack_public_path__ + "media/images/sponsorImage-606ef96ee07165f5dd8ee39190715d50.png";